module.exports = __webpack_public_path__ + "static/img/183031559.51d4983.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/183031559.jpg
// module id = ca6g
// module chunks = 0